import React, { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { cn } from "../../lib/utils";
import SmoothNestedAccordion from "../common-web/NestedAccordion";
import CustomSelect from "../common/CustomSelect";
import ResizableBox from "../common/ResizeableBox";

export default function TdViewerSidebar() {
  const [activeSearchTab, setActiveSearchTab] = useState("On / Off");
  const [activeTab, setActiveTab] = useState("공종");
  const [isShowResult, setIsShowResult] = useState(false);

  return (
    <div className="flex flex-col custom-scrollbar pr-2.5">
      {/* tab btn  */}
      <div className="flex flex-wrap p-2.5 gap-2 border-b border-[#C9C9C9]/30">
        {["On / Off", "Tag Search"].map((it, idx) => (
          <button
            key={idx}
            className={`flex-1 whitespace-nowrap p-1 rounded-[4px] text-[12px] font-bold transition-all ease-linear duration-300 ${
              activeSearchTab === it
                ? "bg-white text-[#242424]"
                : "bg-[#E6E6E6] text-[#797979]"
            }`}
            onClick={() => setActiveSearchTab(it)}
          >
            {it}
          </button>
        ))}
      </div>

      <ResizableBox
        direction="vertical"
        initialSize={400}
        minSize={150}
        maxSize={600}
      >
        
          <div className={cn("p-2.5 pr-0 hidden h-full flex-col gap-2.5", {
            "flex":activeSearchTab === "On / Off"
          })}>
            {/* tab btn  */}
            <div className="flex flex-wrap p-2.5 gap-2 border-b border-[#C9C9C9]/30">
              {["공종", "구조체계", "모델타입", "PBS"].map((it, idx) => (
                <button
                  key={idx}
                  className={`flex-1 p-1 rounded-[4px] text-[12px] font-bold transition-all ease-linear duration-300 whitespace-nowrap max-w-[80px] ${
                    activeTab === it
                      ? "bg-white text-[#242424]"
                      : "bg-[#E6E6E6] text-[#797979]"
                  }`}
                  onClick={() => setActiveTab(it)}
                >
                  {it}
                </button>
              ))}
            </div>

            <div className="w-full overflow-auto h-full flex-1 whitespace-nowrap custom-scrollbar">
              <SmoothNestedAccordion />
            </div>
          </div>
        
          <div className={cn("p-2.5 hidden h-full flex-col gap-2.5", { "flex" :activeSearchTab === "Tag Search" })}>
            {/* input  */}
            <div className="grid grid-cols-3 gap-2.5 border-b border-[#C9C9C9]/30">
              <input
                type="text"
                className="col-span-2 bg-white outline-none w-full border border-[#BABABA]/50 py-1 px-2.5 text-[12px] text-[#242424]"
              />
              <button
                onClick={() => setIsShowResult(true)}
                className="rounded-[3px] bg-[#08F] p-0.5 flex justify-center items-center"
              >
                <AiOutlineSearch color="#fff" size={20} />
              </button>
            </div>

            <p className="text-[12px] font-normal text-[#242424] text-right">
              [ 중 <span className="text-[#08F]">431</span>]
            </p>

            {/* table/search result  */}
            {isShowResult ? (
              <div className="flex flex-wrap gap-x-4 gap-y-3">
                {/* tag  */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium">타입</p>
                  <input
                    type="text"
                    className=" bg-white outline-none w-full border border-[#BABABA]/50 py-1 px-2.5 text-[12px] text-[#242424]"
                    value={431}
                  />
                </div>
                {/* type  */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium">타입</p>
                  <CustomSelect
                    label="태그"
                    value={431}
                    options={[431, 432, 433]}
                    //   onSelect={(val) => handleChange("dev_type", val)}
                    className="text-left"
                    isSearching={true}
                  />
                </div>
                {/* system  */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium">계통</p>
                  <input
                    type="text"
                    className=" bg-white outline-none w-full border border-[#BABABA]/50 py-1 px-2.5 text-[12px] text-[#242424]"
                    value={431}
                  />
                </div>
                {/* building  */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium">건물</p>
                  <CustomSelect
                    label="태그"
                    value={431}
                    options={[431, 432, 433]}
                    //   onSelect={(val) => handleChange("dev_type", val)}
                    className="text-left"
                    isSearching={true}
                  />
                </div>
                {/* designation */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium">명칭</p>
                  <input
                    type="text"
                    className=" bg-white outline-none w-full border border-[#BABABA]/50 py-1 px-2.5 text-[12px] text-[#242424]"
                    value={431}
                  />
                </div>
                {/* Check btn  */}
                <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
                  <p className="text-[11px] text-[#242424] font-medium"></p>
                  <button className="rounded-[3px] bg-[#08F] p-1.5 flex justify-center items-center text-white text-[12px]">
                    조회
                  </button>
                </div>
              </div>
            ) : (
              <div className="w-full overflow-auto custom-scrollbar max-h-full pb-1">
                <table className="text-[#242424] text-[12px] font-normal w-full text-center border border-[#B9B9B9]/30 border-t-0 whitespace-nowrap relative">
                  <thead className="sticky top-0 z-[2]">
                    <tr className="bg-white divide-x divide-[#B9B9B9]/30">
                      {["TAG", "LEVEL", "TYPE", "빌딩", "SCHY"].map(
                        (it, idx) => (
                          <th key={idx}>
                            <div className="px-2 py-1 border-[#B9B9B9]/30 border-t">
                              {it}
                            </div>
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody className="font-light">
                    {["", "", "", ""].map((_, idx) => (
                      <tr
                        key={idx}
                        className="border-t border-[#B9B9B9]/30 divide-x divide-[#B9B9B9]/30"
                      >
                        <td className="px-2 py-1">1-431-P-RC065-1035</td>
                        <td className="px-2 py-1">BO</td>
                        <td className="px-2 py-1">1</td>
                        <td className="px-2 py-1">RCB</td>
                        <td className="px-2 py-1">SCHY</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        
      </ResizableBox>

      {/* Information  */}
      <div className="flex flex-col gap-2.5">
        <div className="bg-white px-2.5 py-2">
          <h6 className="text-[#242424] text-[12px] font-bold">Information</h6>
        </div>
        <div className="flex flex-col gap-2.5 px-2.5">
          {" "}
          <button className="bg-white rounded-[4px] px-7 py-1 text-[#242424] text-[12px] w-fit">
            속성
          </button>
          {/* table  */}
          <div className="w-full overflow-x-auto custom-scrollbar">
            <table className="text-[#242424] text-[12px] font-normal w-full text-center border border-[#B9B9B9]/30 whitespace-nowrap">
              <thead>
                <tr className="bg-[#DBDBDB] divide-x divide-[#B9B9B9]/30">
                  <th className="px-2 py-1">속성</th>
                  <th className="px-2 py-1">값</th>
                </tr>
              </thead>
              <tbody className="font-light">
                {["", "", "", ""].map((_, idx) => (
                  <tr
                    key={idx}
                    className="border-t border-[#B9B9B9]/30 divide-x divide-[#B9B9B9]/30"
                  >
                    <td className="px-2 py-1">TAG_NO</td>
                    <td className="px-2 py-1">1-431-M-RV01</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
